(function () {
  var nf = new Intl.NumberFormat('it-IT');
  var SELECTOR = '.jdgm-all-reviews-text';

  function translate() {
    document.querySelectorAll(SELECTOR).forEach(function (widget) {
      var text = widget.querySelector('.jdgm-all-reviews-text__text');
      var score = widget.querySelector('.jdgm-all-reviews-rating__score');
      if (!text || !score) return;

      var count = parseInt(text.getAttribute('data-number-of-reviews'), 10);
      if (isNaN(count)) return;

      var rating = score.textContent.trim().replace('.', ',');
      var translated = rating + ' su 5 stelle basato su ' + nf.format(count) + ' recensioni';
      // Évite de re-déclencher l'observer en réécrivant le même texte.
      if (text.textContent !== translated) text.textContent = translated;
    });
  }

  function inWidget(node) {
    if (node.nodeType !== 1) node = node.parentElement;
    return !!node && !!node.closest(SELECTOR);
  }

  function containsWidget(node) {
    return node.nodeType === 1 && (!!node.closest(SELECTOR) || !!node.querySelector(SELECTOR));
  }

  function init() {
    translate();

    // Le widget est injecté de façon asynchrone par Judge.me.
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return inWidget(m.target) || Array.prototype.some.call(m.addedNodes, containsWidget);
      });
      if (relevant) translate();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-number-of-reviews', 'data-score']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
